<template>
  <main class="usage-terms">
    <usage-terms-table />
  </main>
</template>

<script>
    import UsageTermsTable from '@views/usage-terms/components/UsageTermsTable.vue'

    export default {
        components: {
          UsageTermsTable
        },

        data() {
            return {

            }
        },

        computed: {
          isAdminUsageTerms() {
            return this.$route.path.includes('/admin')
          } 
        },

        methods: {

        },


        mounted() {
        },

        beforeDestroy() {
        },
    }
</script>

<style lang="scss" scoped>
</style>
